import { AnyAction } from "redux";
import { initialState } from "../../internal/store/initialState";
import { internalActionKeys } from "../../internal/actions/internalActionKeys";

export default function virtualMeetingConnection(
  state: string = initialState.virtualMeetingConnection,
  action: AnyAction
): string {
  switch (action.type) {
    case internalActionKeys.VIRTUAL_MEETING_CONNECTION_TEST:
      return action.payload;
    default:
      return state;
  }
}
